// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--4485w";
export var layoutMain = "Layout-module--layoutMain--wV9y8";